import { Component, computed, EventEmitter, inject, input, Input, Output } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CurrencyPipe, NgClass } from '@angular/common';
import { DiscountDto } from '../../dto';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DiscountPriceComponent } from '../discount-price/discount-price.component';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { TauiBottomSheetModalService } from '@ngx-tailwind-ui/bottom-sheet-modal';

@Component({
  selector: 'webmodule-order-input-panel',
  templateUrl: './input-panel.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  imports: [NgClass, TablerIconsModule, CurrencyPipe, TranslatePipe, DiscountPriceComponent],
  standalone: true,
})
export class InputPanelComponent {
  private readonly translateService = inject(TranslateService);
  private readonly modalService = inject(TauiBottomSheetModalService);
  readonly isPartOfPackage = input<boolean>(false);
  readonly discount = input<DiscountDto | null>();
  @Input({ required: true }) groupName!: string;
  @Input({ required: true }) checked!: boolean;
  @Input({ required: true }) ref!: number | string;
  readonly moreInfoDescription = computed(() => `block.package-option.${this.ref}.more-information`);
  @Input() disabled = false;
  @Input() visualType: 'switch' | 'radio' = 'radio';
  @Input() inputType: 'radio' | 'checkbox' = 'radio';
  @Input() price!: number;
  @Input() priceAlt = 'Inbegrepen';
  @Input() isOneTimePayment = false;
  @Input() customClass!: string;
  @Output() selected: EventEmitter<string | number> = new EventEmitter<string | number>();
  @Output() changed: EventEmitter<string | number> = new EventEmitter<string | number>();
  describedby = computed(() => `${this.groupName}-${this.ref}-description`);
  labelledby = computed(() => `${this.groupName}-${this.ref}-label`);

  openModal(title: string, description: string): void {
    this.modalService.openBottomSheet({
      contentComponent: ModalContentComponent,
      inputs: {
        title: title,
        description: description,
      },
      showCloseButton: true,
      onClose: () => {
        console.log('Modal closed');
      },
    });
  }

  hasTranslationForKey(key: string): boolean {
    const translation = this.translateService.instant(key);
    return translation !== key && translation !== '';
  }
}
